import React from 'react';
import { withStyles, Theme, createStyles, LinearProgress, Card, CardHeader, Button, TextField, Checkbox, FormControlLabel } from "@material-ui/core";
import { withRouter, RouteComponentProps } from "react-router-dom";
import  {SelfTimingEvent, EventEntryList} from '../models/Event';
import {withTranslation, WithTranslation} from 'react-i18next';
import SelfTimingBackend from "../providers/SelfTimingBackend";
import moment from 'moment';

interface events {
    onChange: (field : string ,value : any) => void;
}

class EditEventDetails extends React.Component<SelfTimingEvent & WithTranslation & events,any>
{
    onChange = (field : string) => (ev : React.ChangeEvent<HTMLInputElement>) => {
        let val = ev.target.value as any;
        if (field == "Date")
        {
            val = moment(val).toDate();
        }
        if (field == "EntryOpen" || field == "ShowPublic")
        {
            val = ev.target.checked;
        }
        this.props.onChange(field, val);
    }
    onChangeCheckBox = (field : string) => (ev : React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      this.props.onChange(field, checked);
    }
    render()
    {
        const { classes, t } = this.props as any;
        return <div>
            <div>
                <TextField label="Tävlingsnamn" value={this.props.Name} onChange={this.onChange('Name')} /></div>
                <div><TextField type="date" label="Datum" value={moment(this.props.Date).format("YYYY-MM-DD")} onChange={this.onChange('Date')} /></div>
                <div><TextField label="Arrangör/Ansvarig" value={this.props.Organizer} onChange={this.onChange('Organizer')} /></div>
                <div><TextField label="Ytterligare information" value={this.props.Description} onChange={this.onChange('Description')} /></div>
                <div><FormControlLabel control={
          <Checkbox
            checked={this.props.EntryOpen}
            onChange={this.onChangeCheckBox("EntryOpen")}
            name="entryOpen"
            color="primary"
          />
        }
        label="Öppen för anmälan"
      /></div>
        <div><FormControlLabel control={
          <Checkbox
            checked={this.props.ShowPublic}
            onChange={this.onChangeCheckBox("ShowPublic")}
            name="showPublic"
            color="primary"
          />
        }
        label="Tävlingen synlig i listan över tävlingar"
      /></div>
            </div>;
    }
}

const useStyles = ({ palette, spacing }: Theme) => createStyles({
  
    tableHeader: {
        backgroundColor: palette.primary.light,
        color: 'white'
    },
    formControl: {
        
        margin: '3px',
        minWidth: 200,
      },
      cardHeader: {
        backgroundColor: '#FFFFFF',
        color: '#000000'
      },
        cardHeaderTitle: {
            fontSize: '10px',
            lineHeight: '10px'
        }
  
});

export default withStyles(useStyles)(withTranslation()(EditEventDetails));